import { useSelector } from "react-redux";
import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes;
interface SubmenuItem {
  label: string;
  link: string;
  submenu: boolean;
  showSubRoute: boolean;
  icon: string;
  base: string;
  materialicons: string;
  submenuItems: SubmenuItem[];
  role?: string[];
  count?: number;
}

interface SidebarSection {
  tittle: string;
  icon: string;
  showAsTab: boolean;
  separateRoute: boolean;
  submenuItems: SubmenuItem[];
}

export function SidebarDataTest(language: any, counts: any): SidebarSection[] {

return [
  {
    tittle: language.dash,
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
     
      {
        label: language.utl,
        link: routes.allDashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" , "SEC","SC" ,"INSP", "DT","HJC","SA", "DY","HOS","HJC","SA"]
      },
      {
        label: language.p_eng,
        link: routes.PannelEnginnerDashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT","HJC","SA","DY","HOS","HJC","SA"]
      },
      {
        label: 'GCA Dashboard',
        link: routes.GCADashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" , "SEC","SC" ,"INSP", "DT","HJC","SA","DY","HOS","HJC","SA"]
      },

    ],
    
  },
  {
    tittle: "One Time Form",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Fill form",
        link: routes.apmcDetailApplication,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.pending: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC"]
      },
       {
        label: "My Applications",
        link: routes.myApmcOneTimeApplication,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.pending: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC"]
      },
    ]
  },
    {
    tittle: "One Time Application",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: language.pending,
        link: routes.pendingOneTime,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.pending: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC","COM","Dr","DY","DT","SA"]
      },
    
      {
        label: language.approved,
        link: routes.approvedOneTime,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.approved: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
       role:["JC","COM","Dr","DY","DT","SA"]

      },
      {
        label: language.rejected,
        link: routes.raiseQueryOneTime,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.raiseQuery: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
       role:["JC","COM","Dr","DY","DT","SA"]

      },
    ]
  },
  {
    tittle: "MIS",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
     
      // {
      //   label: language.mis_download,
      //   link: routes.misXLdownload,
      //   submenu: false,
      //   showSubRoute: false,
      //   icon: 'activity',
      //   base: 'activity',
      //   materialicons: 'shutter_speed',
      //   submenuItems: [],
      //   role:["SC" , "DT","HJC","SA", "DY","HOS","HJC"]
      // },
      {
        label: language.mis_upload,
        link: routes.misXLupload,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["ACCT"]
      },
      {
        label: "My Reports",
        link: routes.MISMyApplication,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["ACCT"]
      },
      {
        label: "Annual Reports",
        link: routes.MISAfterApproval,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SC","DT","HJC","HOS","SA","DY"]
      },
    ],
    
  },
    {
    tittle: "MIS",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: language.pending,
        link: routes.PendingMIS,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.pending: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC","JC","COM","Dr"]
      },
    
      {
        label: language.approved,
        link: routes.ApprovedMIS,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.approved: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC","JC","COM" ,"Dr" ]

      },
      {
        label: language.rejected,
        link: routes.RaiseQueryMISMenu,
        submenu: false,
        // count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.raiseQuery: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC","JC" ,"COM" ,"Dr"]

      },
    ]
  },

//    {
//     tittle: language.spon_app,
//     icon: 'file',
//     showAsTab: false,
//     separateRoute: false,
//     submenuItems: [
 
//       {
//         label: language.registration,
//         link: routes.apmc,
//         submenu: true,
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [
//           { label: language.new_reg, link: routes.sponsorRegistration,
//              submenu: false,
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role:["SPO"]
//            },
//           { label: language.my_app, link: routes.spoRegMenu,
//              submenu: false,
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role:["SPO"]
//            },
 
 
//         ],
//         role: ["SPO"]
//       },
 
//       {
//         label: language.agreement,
//         link: routes.menu,
//         submenu: true,
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [
//           { label: language.new_agg, link: routes.sponsorAgreement ,
//              submenu: false,
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role:["SPO"]
//           },
//           { label: language.my_app, link: routes.sponsorDashboard ,
//              submenu: false,
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role:["SPO"]
//           },
 
//         ],
//         role: ["SPO"]
//       },
 
//     ],
//   },
//    {
//  tittle: "Sponsor Registration Applications",
//     icon: 'file',
//     showAsTab: false,
//     separateRoute: false,
//     submenuItems: [
 
//       {
//         label: language.pending,
//         link: routes.sponsorRegistrationPending,
//         submenu: false,
//          count:counts?.cfRegCounts?.pending ? counts?.cfRegCounts?.pending : '',
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role: ["MBA","MBMD","DY","DT","SA"]
//       },
//         {
//         label: language.approved,
//         link: routes.sponsorRegistrationApproved,
//         submenu: false,
//          count:counts?.cfRegCounts?.approved ? counts?.cfRegCounts?.approved : '',
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role: ["MBA","MBMD","DY","DT","SA"]
//       },
//         {
//         label: language.rejected,
//         link: routes.sponsorRegistrationRaiseQuery,
//         submenu: false,
//          count:counts?.cfRegCounts?.raiseQuery ? counts?.cfRegCounts?.raiseQuery : '',
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role: ["MBA","MBMD","DY","DT","SA"]
//       },
 
//       // {
//       //   label: "Sponsor Aggreement Menu",
//       //   link: routes.menuMarketingBoardAgreement,
//       //   submenu: false,
//       //   showSubRoute: false,
//       //   icon: 'activity',
//       //   base: 'activity',
//       //   materialicons: 'shutter_speed',
//       //   submenuItems: [ ],
//       //   role: ["MBA","MBMD"]
//       // },
 
//     ],
//   },
//    {
//  tittle: "Sponsor Agreement Applications",
//     icon: 'file',
//     showAsTab: false,
//     separateRoute: false,
//     submenuItems: [
 
//       {
//         label: language.pending,
//         link: routes.sponsorAgreementPending,
//         submenu: false,
//          count:counts?.cfAggrementCount?.pending ? counts?.cfAggrementCount?.pending : '',
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role: ["MBA","MBMD","DY","DT"]
//       },
//         {
//         label: language.approved,
//         link: routes.sponsorAgreementApproved,
//         submenu: false,
//          count:counts?.cfAggrementCount?.approved ? counts?.cfAggrementCount?.approved : '',
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role: ["MBA","MBMD","DY","DT","SA"]
//       },
//         {
//         label: language.rejected,
//         link: routes.sponsorAgreementRaiseQuery,
//         submenu: false,
//          count:counts?.cfAggrementCount?.raiseQuery ? counts?.cfAggrementCount?.raiseQuery : '',
//         showSubRoute: false,
//         icon: 'activity',
//         base: 'activity',
//         materialicons: 'shutter_speed',
//         submenuItems: [],
//         role: ["MBA","MBMD","DY","DT","SA"]
//       },
 
//       // {
//       //   label: "Sponsor Aggreement Menu",
//       //   link: routes.menuMarketingBoardAgreement,
//       //   submenu: false,
//       //   showSubRoute: false,
//       //   icon: 'activity',
//       //   base: 'activity',
//       //   materialicons: 'shutter_speed',
//       //   submenuItems: [ ],
//       //   role: ["MBA","MBMD"]
//       // },
 
//     ],
//   },
  {
    tittle: language.t_app,
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
     
      {
        label: language.new_app,
        link: routes.licenseRegistrationForm,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["Tr","GCA"]
      },
    
      {
        label: language.mu_app,
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [
              // {label:language.app ,link:routes.traderPending},
              {
                label: language.app,
                link: routes.traderPending,
                submenu: false,
                showSubRoute: false,
                icon: 'activity',
                base: 'activity',
                materialicons: 'shutter_speed',
                submenuItems: [], // nested submenu can be empty
                role: ['Tr', 'GCA'],
              }
            

        ],
        role:["Tr","GCA"]
      },
     
    ],
  },
   {
    tittle: "General Commission Agent",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [

      {
        label: language.new_app,
        link: routes.gcaLicenseRegistrationForm,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
         base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role: ["GCA","Tr"]
      },

      {
        label: language.mu_app,
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [
          {
            label: language.app,
            link: routes.GcaMyApplication,
            submenu: false,
            showSubRoute: false,
            icon: 'activity',
            base: 'activity',
            materialicons: 'shutter_speed',
            submenuItems: [],
            role: ["GCA","Tr"]
          },


        ],
        role: ["GCA","Tr"]
      },

    ],
  },
  //   {
  //   tittle: "General Commission Agent",
  //   icon: 'file',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
     
  //     {
  //       label: language.new_app,
  //       link: routes.gcaLicenseRegistrationForm,
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'activity',
  //       materialicons: 'shutter_speed',
  //       submenuItems: [],
  //       role:["GCA"]
  //     },
    
  //     {
  //       label: language.mu_app,
  //       link: "index",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'activity',
  //       base: 'activity',
  //       materialicons: 'shutter_speed',
  //       submenuItems: [
  //             {label:language.app ,link:routes.GcaMyApplication},
            

  //       ],
  //       role:["GCA"]
  //     },
     
  //   ],
  // },
  
   {
    tittle: language.a_app,
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
     
      {
        label: language.new_app,
        link: routes.apmc,
        submenu: true,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [
            {label:"Schemes" ,link:routes.allSchemes,
               submenu: false,
              showSubRoute: false,
              icon: "activity",
              base: "activity",
              materialicons: "shutter_speed",
              submenuItems: [],
            },
            {
              label: "Forms",
              link: routes.landSchemes,
              submenu: false,
              showSubRoute: false,
              icon: "activity",
              base: "activity",
              materialicons: "shutter_speed",
              submenuItems: [],
            },
                    

        ],
        role:["SEC"]
      },
    
      {
        label: language.mu_app,
        link: routes.menu,
        submenu: true,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [
              {label:language.schemeApplication ,link:routes.menu,
                 submenu: false,
              showSubRoute: false,
              icon: "activity",
              base: "activity",
              materialicons: "shutter_speed",
              submenuItems: [],
              },
              {
                label: language.formApplication,
                link: routes.formApmcApplication,
                submenu: false,
                showSubRoute: false,
                icon: 'activity',
                base: 'activity',
                materialicons: 'shutter_speed',
                submenuItems: [],
              },

        ],
        role:["SEC"]
      },
     
    ],
  },
  {
    tittle: language.pa_eng,
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
     
      {
        label: language.new_app,
        link: routes.panelRegistrationForm,
        submenu: false,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["Per"]
      },
      {
        label: language.mu_app,
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [
              // {label:language.app,link:routes.myApplicationPanel},
              {
                label: language.app,
                link: routes.myApplicationPanel,
                submenu: false,
                showSubRoute: false,
                icon: 'activity',
                base: 'activity',
                materialicons: 'shutter_speed',
                submenuItems: [], // nested submenu can be empty
                role: ['Per'],
              }
 
        ],
        role:["Per"]
      },
     
    ],
  },
  {
    tittle: language.t_app,
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
     
      {
        label: language.pending,
        link: routes.pending,
        submenu: false,
        count:counts?.traderCounts?.pending ? counts?.traderCounts?.pending : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]
      },
      {
        label: language.approved,
        link: routes.firstapproved,
        submenu: false,
        count:counts?.traderCounts?.approved ? counts?.traderCounts?.approved : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]
      },

      {
        label: language.rejected,
        link: routes.rejection,
        submenu: false,
        count:counts?.traderCounts?.raiseQuery ? counts?.traderCounts?.raiseQuery : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]

      },
   
      // {
      //   label: 'Approve Unsigned',
      //   link: routes.approveUnsigned,
      //   submenu: false,
      //   showSubRoute: false,
      //   icon: 'activity',
      //   base: 'activity',
      //   materialicons: 'shutter_speed',
      //   submenuItems: [],
      //   role:["JC"]

      // },

    ],
  },
    {
    tittle: "GCA Applications",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
     
      {
        label: language.pending,
        link: routes.pendingGca,
        submenu: false,
        count:counts?.gcaCounts?.pending ? counts?.gcaCounts?.pending: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC" ,"INSP","JC", "COM" , "Dr" ,"SC" , "DT", "HJC","HOS", "DY","SA" ]
      },
      {
        label: language.approved,
        link: routes.approveGca,
        submenu: false,
        count:counts?.gcaCounts?.approved ? counts?.gcaCounts?.approved : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC","INSP" ,"JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS", "DY","SA" ]
      },

      {
        label: language.rejected,
        link: routes.rejectionGca,
        submenu: false,
        count:counts?.gcaCounts?.raiseQuery ? counts?.gcaCounts?.raiseQuery : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["SEC","INSP" ,"JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS", "DY","SA" ]

      },
   
    

    ],
  },
  {
    tittle: language.pa_eng,
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [     
      {
        label: language.pending,
        link: routes.pending_panel,
        submenu: false,
        count:counts?.panelCounts?.pending ? counts?.panelCounts?.pending : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]
      },
    
      {
        label: language.approved,
        link: routes.panelApproved,
        submenu: false,
        count:counts?.panelCounts?.approved ? counts?.panelCounts?.approved : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]

      },
      {
        label: language.rejected,
        link: routes.panelRejection,
        submenu: false,
        count:counts?.panelCounts?.raiseQuery ? counts?.panelCounts?.raiseQuery : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]

      },
   
    ],
  },
  {
    tittle: "APMC Schemes Applications",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [     
      {
        label: language.pending,
        link: routes.apmcPendingApp,
        submenu: false,
        count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.pending: '',

        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr"  , "DT", "SC","HOS","SA", "DY" ]
      },
    
      {
        label: language.approved,
        link: routes.apmcApprovedApp,
        submenu: false,
        count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.approved: '',

        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" , "DT", "SC","HOS","SA", "DY" ]

      },
      {
        label: language.rejected,
        link: routes.apmcRejectedApp,
        submenu: false,
        count:counts?.apmcFormCounts?.pending ? counts?.apmcSchemeCounts?.raiseQuery: '',

        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" , "DT", "SC","HOS","SA", "DY" ]

      },
   
    ],
  },
   {
    tittle: "APMC Forms Applications",
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [     
      {
        label: language.pending,
        link: routes.apmcFormsPendingApp,
        submenu: false,
        count:counts?.apmcFormCounts?.pending ? counts?.apmcFormCounts?.pending: '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]
      },
    
      {
        label: language.approved,
        link: routes.apmcFormsApprovedApp,
        submenu: false,
        count:counts?.apmcFormCounts?.approved ? counts?.apmcFormCounts?.approved : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" ,"SC" , "DT", "HJC","HOS","SA", "DY" ]

      },
      {
        label: language.rejected,
        link: routes.apmcFormsRejectedApp,
        submenu: false,
        count:counts?.apmcFormCounts?.raiseQuery ? counts?.apmcFormCounts?.raiseQuery : '',
        showSubRoute: false,
        icon: 'activity',
        base: 'activity',
        materialicons: 'shutter_speed',
        submenuItems: [],
        role:["JC" , "COM" , "Dr" , "SC" , "DT", "HJC","HOS","SA", "DY" ]

      },
   
    ],
  },
  // {
  //   tittle: "Main Menu",
  //   icon: "airplay",
  //   showAsTab: true,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Dashboard",
  //       link: "index",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "smart-home",
  //       base: "dashboard",
  //       materialicons: "start",
  //       dot: true,
  //       submenuItems: [
  //         { label: "Dashboard", link: routes.AdminnDashboard },
  //         // {label:"deals-Dashboard",link:routes.dealsDashboard},

  //         { label: "Profile", link: routes.profile },

  //         // { label: "Area Grid Creation", link: routes.areaGrid },
  //         // { label: "Grid Allotment", link: routes.gridAllotment },
  //         // { label: "Reports", link: routes.reports },
  //       ],
  //     },
  //   ]
  // },
  // {
  //   tittle: 'APMC',
  //   icon: 'file',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
     
  //     {
  //       label: 'Manage APMC',
  //       link: routes.manage_apmc,
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'activity',
  //       base: 'activity',
  //       materialicons: 'shutter_speed',
  //       submenuItems: [],
  //     },
  //   ],
  // },
 
  //   {
  //   tittle: 'Administration',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
    
   
  //     {
  //       label: 'User Management',
  //       base: 'user-management',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'user-star',
  //       submenuItems: [
  //         {
  //           label: 'Users',
  //           link: routes.users,
  //           base: 'users',
  //         },
  //         {
  //           label: 'Roles & Permissions',
  //           link: routes.rolePermission,
  //           base: 'roles-permissions',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Manage Approval',
  //       link: routes.manage_approval,
  //       base: 'user-approval',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'user-star',
  //       submenuItems: [],
  //     },
  
  
 
]};
